/** The wizard's `RightsOfUseEnum` values — reused as-is for both `rightsOfUse`
 * (step 5, "Derecho de uso") and `postInProfileTime` ("Tiempo en perfil"). */
const RIGHTS_OF_USE_VALUE: Record<string, string> = {
  "three months": "3 meses",
  "six months": "6 meses",
  "twelve months": "12 meses",
  forever: "Para siempre",
};

export const rightsOfUseValue = (raw: string | null): string | null =>
  raw ? (RIGHTS_OF_USE_VALUE[raw] ?? raw) : null;
